<template>
    <div>
        <div style="margin-top: 10px;">
            <p><h5>{{ $t('objects.details.change-protocol') }}</h5></p>
        </div>
        <div>
            <rms-objects-history-grid v-if="rmsobjectid"
                                      :rmsobjectid="rmsobjectid">
            </rms-objects-history-grid>
        </div>
    </div>
</template>

<script>
    // Template für Spalte Bild
    import RmsObjectsHistoryGrid from "./rms-objects-history-grid";

    export default {
        name: "rms-objects-history-tab",
        components: {RmsObjectsHistoryGrid},
        props: ['user', 'rmsobjectid'],
        data: function() {
            return {}
        },
        mounted() {
        },
        methods: {}
    }
</script>

<style scoped>

</style>
